import { Credential, CredentialEntity } from '../..';
import { Mapper } from '../../../@harmony';

export class CredentialToCredentialEntityMapper implements Mapper<Credential, CredentialEntity> {
  public map(from: Credential): CredentialEntity {
    return {
      authType: from.authType,
      provider: from.provider,
      accessToken: from.accessToken,
      expiresAt: from.expiresAt,
      refreshToken: from.refreshToken,
      scopes: from.scopes,
      metadata: from.metadata,
    };
  }
}

export class CredentialEntityToCredentialMapper implements Mapper<CredentialEntity, Credential> {
  public map(from: CredentialEntity): Credential {
    return new Credential(
      from.authType,
      from.provider,
      from.accessToken,
      from.expiresAt,
      from.refreshToken,
      from.scopes,
      from.metadata,
    );
  }
}
